import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { MdDelete } from 'react-icons/md'
import Switch from 'react-switch'
import * as reducks from '../../../../reducks'
import Modal from '../../Modal/Modal'
import Flex from '../../Flex/Flex'
import Text from '../../Text/Text'
import Button from '../../Button/Button'
import Tabs from '../../Tabs/Tabs'

export const TABS_OPTIONS = [
  {
    name: 'Produção',
    id: 'production'
  },
  {
    name: 'Nome da loja',
    id: 'name_fantasy',
    order: true
  }
]

const ORDER_DIRECTION_ASC = 'asc'
const ORDER_DIRECTION_DEFAULT = 'desc'
const ORDER_BY_PERMITION_SORT = 'name_fantasy'

export const handleChange = (value, setValue) => {
  setValue({ orderBy: value })
}

export const handleClear = async (setValue) => {
  setValue({ orderBy: undefined, orderByDirection: 'desc' })
}

export const handleSubmit = (value, closeCallback, dispatch) => {
  dispatch(reducks.resources.wallet.actions.walletApplyFilters(value))
  closeCallback()
}

const ModalOrder = ({ filters, visible, closeCallback }) => {
  const dispatch = useDispatch()

  const [value, setValue] = useState({
    orderBy: filters.orderBy,
    orderByDirection: filters.orderByDirection
  })

  useEffect(() => {
    setValue({
      orderBy: filters.orderBy,
      orderByDirection: filters.orderByDirection
    })
  }, [visible, filters.orderBy, filters.orderByDirection])

  return (
    <Modal
      visible={visible}
      size="small"
      height="312px"
      padding="40px 32px"
      rounded
      onClickOverlay={closeCallback}
      HeaderContent={() => (
        <>
          <Text
            value="Ordenar por"
            size="md"
            color="gray"
            variation="dark"
            bold
          />
          <button type="button" onClick={() => handleClear(setValue)}>
            <Text
              value="Limpar"
              color="gray"
              variation="dark"
              size="xxs"
              margin="0px 5px 0px 0px"
            />
            <MdDelete color="#4D4D4D" size={15} />
          </button>
        </>
      )}
    >
      <>
        <Flex alignItems="center" justifyContent="center" margin="40px 0px 0px">
          <Tabs
            tabs={TABS_OPTIONS}
            onChange={(tab) =>
              setValue({
                orderByDirection:
                  tab.id === ORDER_BY_PERMITION_SORT
                    ? value.orderByDirection
                    : ORDER_DIRECTION_DEFAULT,
                orderBy: tab.id
              })
            }
            initialValue={value.orderBy}
          />
        </Flex>
        <Flex alignItems="center" justifyContent="center" margin="10px">
          <Text size="xs" margin="0px 5px" color="gray" variation="dark">
            {value.orderBy === ORDER_BY_PERMITION_SORT ? 'A-Z' : '↑'}
          </Text>
          <Switch
            height={22}
            width={40}
            uncheckedIcon={false}
            checkedIcon={false}
            onColor="#ec0000"
            checked={value.orderByDirection !== ORDER_DIRECTION_ASC}
            onChange={(checked) => {
              setValue({
                ...value,
                orderByDirection: checked
                  ? ORDER_DIRECTION_DEFAULT
                  : ORDER_DIRECTION_ASC
              })
            }}
          />
          <Text size="xs" margin="0px 5px" color="gray" variation="dark">
            {value.orderBy === ORDER_BY_PERMITION_SORT ? 'Z-A' : '↓'}
          </Text>
        </Flex>

        <Flex alignItems="center" justifyContent="center" margin="38px 0px 0px">
          <Button
            width="234px"
            type="secondary"
            buttonType="button"
            onClick={() => handleSubmit(value, closeCallback, dispatch)}
          >
            Ver Resultado
          </Button>
        </Flex>
      </>
    </Modal>
  )
}

ModalOrder.defaultProps = {
  closeCallback: null,
  filters: {
    orderBy: undefined,
    orderByDirection: 'desc'
  },
  visible: true
}

ModalOrder.propTypes = {
  closeCallback: PropTypes.func,
  filters: PropTypes.shape({
    orderBy: PropTypes.string,
    orderByDirection: PropTypes.string
  }),
  visible: PropTypes.bool
}

export default ModalOrder
